export type AlertLevel = 'error' | 'warn' | 'info' | 'success';

export const pageNames = [
  'IssueReport',
  'IssueConfiguration',
  'JobStationAssignments',
  'CellBoardMessage',
  'CrewingGuide',
  'CrewingEmployeeSearch',
  'Scoreboard',
  'Dashboard',
  'SupportHierarchy',
  'SchedulingToolCapacityUtilization',
  'SchedulingToolSalesOrders',
  'SchedulingToolLaborWhatIf',
  'Lsw',
] as const;
export type PageName = (typeof pageNames)[number];

export type HelpLinkDto = {
  id: string;
  pageName: PageName;
  linkUrl: string;
};

export type HelpLinkCreate = {
  pageName: PageName;
  linkUrl: string;
};

export type HelpLinkUpdate = {
  linkUrl: string;
};

export type UserFeedbackConfigDto = {
  id: string;
  inventoryCenterId: string;
  recipientIds: string[];
};

export type UserFeedbackConfigCreate = {
  inventoryCenterId: string;
  recipientIds: string[];
};

export type UserFeedbackConfigUpdate = {
  recipientIds: string[];
};

/**
 * SharePoint document library metadata returned by the admin discovery endpoint.
 * Mirrors the backend `SharepointLibraryInfo` model.
 */
export type SharepointLibraryInfo = {
  /** SharePoint list name used by Graph APIs (e.g., what the backend filters against). */
  name: string;
  /** Human-friendly label shown in the admin UI dropdowns. */
  displayName: string;
};

/**
 * SharePoint column metadata returned by the admin discovery endpoint.
 * Mirrors the backend `SharepointColumnInfo` model.
 */
export type SharepointColumnInfo = {
  /** Human-friendly label shown in the admin UI dropdowns. */
  displayName: string;
  /** Internal Graph field name used to build filter expressions at read time. */
  internalName: string;
};

export type BreaktimeAnnouncementConfigSummary = {
  inventoryCenterId: string;
  inventoryCenterCode: string;
  inventoryCenterDescription: string;
  isConfigured: boolean;
  contentUrl: string | null;
  audienceMode: BreaktimeAnnouncementAudienceMode | null;
  affectedMCellCount: number;
  affectedMCellCollectionCount: number;
};

export type BreaktimeAnnouncementAudienceMode = 'Exclude' | 'Include';

export type BreaktimeAnnouncementAffectedMCell = {
  mCellId: string;
  code: string;
  description: string;
};

export type BreaktimeAnnouncementAffectedMCellCollection = {
  mCellCollectionId: string;
  name: string;
  targetableMemberCount: number;
  totalMemberCount: number;
};

export type BreaktimeAnnouncementConfig = {
  id: string;
  inventoryCenterId: string;
  contentUrl: string | null;
  audienceMode: BreaktimeAnnouncementAudienceMode;
  affectedMCells: BreaktimeAnnouncementAffectedMCell[];
  affectedMCellCollections: BreaktimeAnnouncementAffectedMCellCollection[];
};

export type BreaktimeAnnouncementConfigInput = {
  contentUrl: string | null;
  audienceMode: BreaktimeAnnouncementAudienceMode;
  affectedMCellIds: string[];
  affectedMCellCollectionIds: string[];
};
